/*! @azure/msal-common v12.1.0 2023-04-18 */
'use strict';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function isCloudInstanceDiscoveryErrorResponse(response) {
  return response.hasOwnProperty("error") && response.hasOwnProperty("error_description");
}
export { isCloudInstanceDiscoveryErrorResponse };